import { countryCodeToLengthMap } from 'entities/users/consts';

export const validatePhoneNumber = (countryCode: string, value: string) => {
  const expectedLength = countryCodeToLengthMap[countryCode];
  return expectedLength !== undefined ? new RegExp(`^\\d{${expectedLength}}$`).test(value) : false;
};
